<div class="container">
    <div class="card p-3">
        <div class="row g-3">

            <div class="col-lg-4">
                <div #point></div>
            </div>
            <div class="col-4"></div>
            <div class="col-lg-4">
                <div #member></div>
            </div>
            <div class="col-lg-6">
                <div #reward></div>
            </div>
            <div class="col-lg-6">
                <div #coupon></div>
            </div>
        </div>
    </div>
</div>